import React from "react";
import {Switch} from "./Switch";
import type {SwitchProps} from "./Switch";
import {FieldsetLayout} from "./FieldsetLayout";
import {GridCell, GridContainer} from "../Grid";

interface SwitchFieldsetProps extends SwitchProps {
    children?: React.ReactNode;
    legend?: string;
}

export const SwitchFieldset: React.FC<SwitchFieldsetProps> = ({
	                               activeLabel,
	                               value,
	                               children,
	                               inactiveLabel,
	                               name,
	                               onChange,
	                               label,
	                               legend,
                               }: SwitchFieldsetProps) => {

	return (
		<FieldsetLayout
			className="toggled__container"
			legend={legend}
			name={name}
		>
			<GridContainer hasMarginX>
				<GridCell>
					<Switch activeLabel={activeLabel} value={value} inactiveLabel={inactiveLabel}
					        name={name} onChange={onChange} label={label}/>
				</GridCell>
				{children}
			</GridContainer>
		</FieldsetLayout>
	);
};
